import React, { useMemo } from 'react';
import { ModelEditorFactory, SharedContext } from '@leverege/ui-plugin';
import Model from "../model/FilterAggModel.js";
import ConditionFilterOptionsCreators from "../../../../filters/filter/ConditionFilterOptionsCreators.js";
import ConditionFilterModelInitializer from "../../../../filters/filter/ConditionFilterModelInitializer.js";
import { FilterSourceModel } from "../../../../filters/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function FilterAggEditor(props) {
  const {
    eventData,
    onChange,
    delegate,
    objectType,
    value: pValue,
    relationship
  } = props;
  const value = useMemo(() => {
    return pValue?.filter?.metadata || ConditionFilterModelInitializer.create(delegate.type, objectType);
  }, [pValue, delegate.type, objectType]);
  const testOnChange = evt => {
    const filter = delegate.convertToFilter(evt.value, {
      objectType
    });
    let nFilterModel = FilterSourceModel.setMetadata(pValue.filter, evt.value);
    nFilterModel = FilterSourceModel.setFilter(nFilterModel, filter);
    const nValue = Model.setFilter(pValue, nFilterModel);
    onChange({
      data: eventData,
      value: nValue
    });
  };
  const editor = ModelEditorFactory.create(value, {
    context: {
      clientProps: props,
      objectType
    },
    clientProps: props,
    delegate,
    relationship,
    onChange: testOnChange
  });
  const optionsCreator = ConditionFilterOptionsCreators.getOptionsCreatorFor(delegate.type, objectType);
  const {
    creators,
    conditionOptions
  } = optionsCreator?.create?.(props) || {};
  return /*#__PURE__*/_jsx(SharedContext, {
    conditionOptions: conditionOptions,
    conditionCreators: creators,
    objectType: objectType,
    delegate: delegate,
    relationship: relationship,
    children: editor
  });
}